"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Object.freeze({
    EDDYSTONE_CONFIG_SERVICE_UUID: 'a3c87500-8ed3-4bdf-8a39-a01bebede295',
    CAPABILITIES_CHARACTERISTIC_UUID: 'a3c87501-8ed3-4bdf-8a39-a01bebede295',
    ACTIVE_SLOT_CHARACTERISTIC_UUID: 'a3c87502-8ed3-4bdf-8a39-a01bebede295',
    ADVERTISING_INTERVAL_CHARACTERISTIC_UUID: 'a3c87503-8ed3-4bdf-8a39-a01bebede295',
    RADIO_TX_POWER_CHARACTERISTIC_UUID: 'a3c87504-8ed3-4bdf-8a39-a01bebede295',
    ADVANCED_ADVERTISED_TX_POWER_CHARACTERISTIC_UUID: 'a3c87505-8ed3-4bdf-8a39-a01bebede295',
    EDDYSTONE_LOCK_STATE_CHARACTERISTIC_UUID: 'a3c87506-8ed3-4bdf-8a39-a01bebede295',
    EDDYSTONE_UNLOCK_CHARACTERISTIC_UUID: 'a3c87507-8ed3-4bdf-8a39-a01bebede295',
    PUBLIC_ECDH_KEY_CHARACTERISTIC_UUID: 'a3c87508-8ed3-4bdf-8a39-a01bebede295',
    EID_IDENTITY_KEY_CHARACTERISTIC_UUID: 'a3c87509-8ed3-4bdf-8a39-a01bebede295',
    ADV_SLOT_DATA_CHARACTERISTIC_UUID: 'a3c8750a-8ed3-4bdf-8a39-a01bebede295',
    ADVANCED_FACTORY_RESET_CHARACTERISTIC_UUID: 'a3c8750b-8ed3-4bdf-8a39-a01bebede295',
    ADVANCED_REMAIN_CONNECTABLE_CHARACTERISTIC_UUID: 'a3c8750c-8ed3-4bdf-8a39-a01bebede295',
});
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/eddystone-web-bluetooth/dist/constants.js
// module id = 46
// module chunks = 0